import { AxiosError } from 'axios';

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

export const LOGIN_RATE_LIMIT_MESSAGE =
  'Too many login attempts. Please wait and try again later.';

export const FORGOT_PASSWORD_RATE_LIMIT_MESSAGE =
  'Too many password reset requests. Please wait and try again later.';

type ApiError = {
  status?: number;
  data?: { message?: string; statusCode?: number };
  response?: AxiosError['response'];
};

export const getApiErrorStatus = (error: ApiError): number | undefined =>
  error.response?.status ?? error.status;

export const isRateLimitError = (error: ApiError): boolean =>
  getApiErrorStatus(error) === 429;

export const getRateLimitMessage = (
  error: ApiError,
  fallback: string,
): string => {
  const axiosMessage = (
    error.response?.data as { message?: string } | undefined
  )?.message;
  const message = axiosMessage ?? error.data?.message;

  return typeof message === 'string' && message.length > 0 ? message : fallback;
};
